import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.cancellation-reasons')
  .service('CancellationReasonsAPI', CancellationReasonsAPI);

function CancellationReasonsAPI(): BringozApi {
  return {
    base: `/cancellationReason`,
    infiniteScroll: {
      address: `/cancellationReason`,
      cmd: 'GET'
    },
    actions: {
      createCancellationReason: {
        address: '',
        cmd: 'POST',
        updateable: true
      },
      updateCancellationReason: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      deleteCancellationReason: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
    }
  }
}
